export default __webpack_public_path__ + "static/imgBackgroundMobile-c2677eecf6d93b6161b096a3952080bf.png";